export default "__VITE_ASSET__CDFvX4Zu__"